import { PhoneCountryType } from "@shared/lib/libphonenumber/api";
import yup from "@shared/lib/yupExtensions/index";
import { t } from "@shared/utils/internationalization";

export const smsDeliverySchema = (phoneCountry: PhoneCountryType) =>
  yup.object().shape({
    phone: yup
      .string()
      .required(t("Phone number is required"))
      .phone(t("Invalid phone number for selected country"), phoneCountry),
  });
